import axiosInstance from '../axios/axios';

// _queueName kept for API compatibility — the backend always targets 'import-master'
export const sendMessage = async (_queueName: string, messageText: string): Promise<void> => {
  await axiosInstance.post('api/enqueue-import', JSON.parse(messageText));
};
